import { useLang } from '@/app/utils/useLang';
import { getSolarRecommand } from '@/service/solar-calculator';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';

const Comparison: React.FC = () => {
    const { t } = useLang('Comparison');
    const { locale = 'us' } = useRouter();
    const [list, setList] = useState();

    const specItems = (row: number) => {
        return [...new Array(13)].map((item, index) => {
            return {
                desc: t(`item${row + 1}_desc${index + 1}`) || t(`item_desc${index + 1}`),
                title: t(`item${row + 1}_title${index + 1}`),
            };
        });
    };

    // 按区域和产品ID组织配置
    const PRODUCT_CONFIG = {
        us: {
            item1: { productId: '15386143096905', variantId: '54718705008713' },
            item2: { productId: '15386143096905', variantId: '54692148871241' },
        },
        ca: {
            item1: { productId: '15164531016051', variantId: '62106740556147' },
            item2: { productId: '15164531016051', variantId: '62060629590387' },
        },
    };
    const getProductConfig = (itemName: any) => PRODUCT_CONFIG[locale]?.[itemName] || PRODUCT_CONFIG.us[itemName];

    let items = [
        {
            subItems: [
                {
                    title: t('item1_title'),
                    // desc: t('item1_desc'),
                    lChildren: t('item1_btn'),
                    lDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-1 .l-item-btn`,
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item1_btn')}`,
                        page_name: 'EcoFlow DELTA 3 Ultra Plus (3072Wh)',
                    },
                    rChildren: t('item1_more'),
                    // rHref: `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station`,
                    rDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-1 .r-item-btn`,
                        event: 'uaEvent',
                        event_name: 'buy',
                        position: t('item2_more'),
                    },
                    productId: getProductConfig('item1').productId,
                    variantId: getProductConfig('item1').variantId,
                    specItems: specItems(0),
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item2_title'),
                    // desc: t('item2_desc'),
                    lChildren: t('item2_btn'),
                    lDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-2 .l-item-btn`,
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item2_btn')}`,
                        page_name: 'EcoFlow DELTA 3 Ultra Plus (3072Wh)',
                    },
                    rChildren: t('item2_more'),
                    // rHref: `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station`,
                    rDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-2 .l-item-btn`,
                        event: 'uaEvent',
                        event_name: 'buy',
                        position: t('item2_more'),
                    },
                    productId: getProductConfig('item2').productId,
                    variantId: getProductConfig('item2').variantId,
                    specItems: specItems(1),
                },
            ],
        },
    ];

    const getAsynItem = async (productId: string, variantId: string) => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const promises = items?.map((item: any) => getAsynItem(item?.subItems[0].productId, item.subItems[0].variantId));
        Promise.all(promises).then((res) => {
            const old = JSON.parse(JSON.stringify(items));
            const list = res.map((i: any, idx) => {
                const variantId = getProductConfig(`item${idx + 1}`).variantId;
                if (i.data.variantImg) {
                    old[idx].subItems[0].pc = i.data.variantImg;
                }

                if (i.data.inventoryQuantity === 0) {
                    old[idx].subItems[0].lChildren = t(`item${idx + 1}_sold`);
                    old[idx].subItems[0].lDisabled = true;
                }

                const title = i.data.skuTitle.split(' / ')[0];
                console.log('title', title);
                old[idx].subItems[0].title = title;
                // old[idx].subItems[0].lHref = `https://${locale}.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=${variantId}`;
                old[idx].subItems[0].lHref = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                old[idx].subItems[0].rHref = `https://${locale}.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=${variantId}`;
                old[idx].subItems[0].lDataLayer.product_name = title;
                old[idx].subItems[0].rDataLayer.product_name = title;
                old[idx].subItems[0].lDataLayer.__btn_id2 = old[idx].subItems[0].lHref;
                old[idx].subItems[0].rDataLayer.__btn_id2 = old[idx].subItems[0].rHref;

                return old[idx];
            });
            items = JSON.parse(JSON.stringify(list));

            setList(list as any);
        });
    }, []);

    return (
        <div className={`page-comparison GtmModuleData-section ${styles.Comparison}`} data-section-id="d3m-comparison">
            <EcoSectionCommon title={t('title')} />
            {list && <EcoCompareProduct items={list}></EcoCompareProduct>}
        </div>
    );
};

export default Comparison;
